(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-custom-select]').forEach((selectWrapper) => {
    const select = selectWrapper.querySelector('select');
    const trigger = selectWrapper.querySelector('.custom-select__trigger');
    const text = selectWrapper.querySelector('.custom-select__text');
    const dropdown = selectWrapper.querySelector('.custom-select__dropdown');

    const selectedOption = select.options[select.selectedIndex];
    text.textContent = selectedOption.textContent;

    Array.from(select.options).forEach((option) => {
      const div = document.createElement('div');
      div.classList.add('custom-select__option');
      div.textContent = option.textContent;

      if (option.selected) {
        div.classList.add('selected');
      }

      div.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        text.textContent = option.textContent;

        dropdown.querySelectorAll('.selected').forEach((el) => {
          el.classList.remove('selected');
        });

        div.classList.add('selected');
        selectWrapper.classList.remove('open');
      });

      dropdown.appendChild(div);
    });

    trigger.addEventListener('click', () => {
      selectWrapper.classList.toggle('open');
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-custom-select]')) {
      document.querySelectorAll('.custom-select').forEach((el) => {
        el.classList.remove('open');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
